import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ProgressDialogComponent } from './progress-dialog/progress-dialog.component';

@Component({
  selector: 'app-report-running-progress-dialog',
  templateUrl: './report-running-progress-dialog.component.html'
  // styleUrls: ['./report-running-progress-dialog.component.scss']
})
export class ReportRunningProgressDialogComponent implements OnInit, OnChanges {

  @Input() open: boolean;

  dialogRef = null;

  constructor(
    public dialog: MatDialog
  ) {
    this.open = false;
  }

  ngOnInit() {}

  ngOnChanges() {

    setTimeout(() => {
      if (this.open) {
        this.openDialog();
      } else {
        this.closeDialog();
      }
    }, 200);

  }

  openDialog(): void {

    this.dialogRef = this.dialog.open(ProgressDialogComponent, {
      autoFocus: false,
      disableClose: true,
      width: '400px'
    });

  }

  closeDialog(): void {

    if (this.dialogRef) {
      this.dialogRef.close();
    }

  }

}
